import { injectJS, injectCSS } from './utils';
import { Capacitor } from '@capacitor/core';

export async function initGDPR() {
  if (!Capacitor.isNativePlatform()) {
    await injectJS(
      'gdpr-js',
      'https://cdnjs.cloudflare.com/ajax/libs/cookieconsent2/3.1.0/cookieconsent.min.js'
    );
    await injectCSS(
      'gdpr-css',
      'https://cdnjs.cloudflare.com/ajax/libs/cookieconsent2/3.1.0/cookieconsent.min.css'
    );
    initialiseCookieConsent();
  } else {
    console.debug('on native, no gdpr');
  }
}

function initialiseCookieConsent() {
  if (window['cookieconsent']) {
    window['cookieconsent'].initialise({
      palette: {
        popup: {
          background: '#2d3e4d',
          text: '#ffffff',
        },
        button: {
          background: '#6bbcee',
          text: '#ffffff',
        },
      },
      theme: 'edgeless',
      position: 'bottom-left',
      content: {
        message:
          'Sworkit uses cookies to ensure you get the best experience on our web app. ',
        href: 'https://m.sworkit.com/privacy.html',
      },
    });
  }
}
